// extracted by mini-css-extract-plugin
export var black = "_4e-6";
export var brand = "_4e-1";
export var ddefault = "_4e-0";
export var error = "_4e-3";
export var gray = "_4e-2";
export var highContrast = "_4e-8";
export var outline = "_4e-7";
export var success = "_4e-5";
export var warning = "_4e-4";